/**
 * Strutture Page - Page Shell
 * Imports StrutturaList from features/strutture
 * Data fetched via React Query hooks
 */

import { StrutturaList } from "@/features/strutture";

export default function Strutture() {
  return <StrutturaList />;
}
